
import { useState } from "react";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ProfileForm } from "./ProfileForm";
import { SecurityForm } from "./SecurityForm";
import { NotificationForm } from "./NotificationForm";

interface AccountSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function AccountSheet({ open, onOpenChange }: AccountSheetProps) {
  const [activeTab, setActiveTab] = useState("profile");

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent 
        side="bottom" 
        className="fixed inset-0 w-full h-full focus:outline-none focus-visible:outline-none focus:ring-0 sm:h-auto sm:w-[540px] sm:inset-auto sm:top-[50%] sm:left-[50%] sm:-translate-x-[50%] sm:-translate-y-[50%]"
      >
        <SheetHeader>
          <SheetTitle>Account Settings</SheetTitle>
        </SheetHeader>
        <div className="mt-6">
          <Tabs value={activeTab} onValueChange={setActiveTab}>
            <TabsList className="grid w-full grid-cols-3">
              <TabsTrigger value="profile">Profile</TabsTrigger>
              <TabsTrigger value="security">Security</TabsTrigger>
              <TabsTrigger value="notifications">Notifications</TabsTrigger>
            </TabsList>
            <TabsContent value="profile" className="mt-4">
              <ProfileForm />
            </TabsContent>
            <TabsContent value="security" className="mt-4">
              <SecurityForm />
            </TabsContent>
            <TabsContent value="notifications" className="mt-4">
              <NotificationForm />
            </TabsContent>
          </Tabs>
        </div>
      </SheetContent>
    </Sheet>
  );
}
